import { render, staticRenderFns } from "./MarketingHub.vue?vue&type=template&id=7504c87a"
import script from "./MarketingHub.vue?vue&type=script&lang=js"
export * from "./MarketingHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports